angular.module('bmsApp.accounting').controller('InvoiceIndexCustomerSMJobCtrl', function ($scope) {
	$scope.customerInvoices = $scope.job.invoices;
});
